import React from "react";
import Typewriter from "typewriter-effect";

function Type({ texto }) {
  return (
    <Typewriter
      options={{
        strings: [texto],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
      style={{ color: "blue" }}
    />
  );
}

export default Type;
